import React from 'react';

const results = [
  {
    icon: '📅',
    label: 'More booked jobs',
    desc: 'Your calendar fills up automatically.',
  },
  {
    icon: '⚡',
    label: 'Faster response = higher close rate',
    desc: 'First to respond wins the job. Every time.',
  },
  {
    icon: '🔁',
    label: 'Less manual work',
    desc: 'Stop spending hours on admin tasks that can be automated.',
  },
  {
    icon: '💰',
    label: 'More revenue without hiring staff',
    desc: 'Scale your business without adding headcount.',
  },
];

export default function Results() {
  return (
    <section className="py-32 px-6 w-full" style={{ background: '#082318' }}>
      <div className="max-w-[1100px] mx-auto">
        <div className="text-center mb-16">
          <p className="text-xs font-mono uppercase tracking-widest mb-4 font-semibold" style={{ color: '#d4f542' }}>Impact</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white tracking-tight mb-4">
            What This Means For You
          </h2>
          <p className="text-base italic max-w-lg mx-auto" style={{ color: 'rgba(255,255,255,0.5)' }}>
            "1 automation can replace hours of daily work."
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {results.map((r, i) => (
            <div
              key={i}
              className="p-8 rounded-2xl flex flex-col text-center"
              style={{ background: '#0c2d1e', border: '1px solid rgba(255,255,255,0.07)' }}
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center text-xl mx-auto mb-5"
                style={{ background: 'rgba(212,245,66,0.1)' }}
              >
                {r.icon}
              </div>
              <h3 className="text-base font-bold text-white mb-2 leading-tight">{r.label}</h3>
              <p className="text-sm leading-relaxed" style={{ color: 'rgba(255,255,255,0.5)' }}>{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
